import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import Items from './Items';
import columnTypes from '../../components/cms/grid/columnTypes';
import ModelService from '../../services/company.service';
import { Badge } from 'reactstrap';
import gc from '../../components/cms/gridComponents';
import PreviewImage from '../../components/previewImage';
import CompanyService from "../../services/company.service";

const convertSecToHours = seconds => Math.round(seconds/6/6/100)/1000;

const getMetrics = ({ item: { metrics } }) => (
  <div className="metrics-block">
    <ul>
      <li>Last activity: <Badge color="info">{metrics.lastActivity || '-'}</Badge></li>
      <li>Total activity: <Badge color="info">{metrics.totalActivity}</Badge></li>
      <li>Last 30 days activity: <Badge color="info">{metrics.last30DaysActivity}</Badge></li>
      <li>Total rendered exports: <Badge color="info">{metrics.totalRenderedVideos}</Badge></li>
      <li>Last 30 days exports: <Badge color="info">{metrics.last30DaysRenderedVideos}</Badge></li>
      <li>Total exports time: <Badge color="info">{convertSecToHours(metrics.totalRenderedVideoTime)}h</Badge></li>
      <li>Last 30 days exports time: <Badge color="info">{convertSecToHours(metrics.last30DaysRenderedVideoTime)}h</Badge></li>
      <li>Total csv exports: <Badge color="info">{metrics.totalCsvExports}</Badge></li>
      <li>Total downloads: <Badge color="info">{metrics.totalDownloads}</Badge></li>
      <li>Total unique downloads: <Badge color="info">{metrics.totalUniqueDownloads}</Badge></li>
      <li>Last 30 days downloads: <Badge color="info">{metrics.last30DaysDownloads}</Badge></li>
      <li>Last 30 days uniq downloads: <Badge color="info">{metrics.last30DaysUniqueDownloads}</Badge></li>
    </ul>
  </div>
);

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>),
  },
  {
    name: 'title',
    title: t('Title'),
    value: ({ item }) => (<div>
      <Link to={ModelService.getUpdateUrl(item.id)}>{item.title}</Link>
      <div>Tokens: {item.tokens}</div>
      <div className="">
        <Link to={ModelService.getUpdateUrl(item.id)}>
          <PreviewImage height="35" src={ModelService.getImage(item.logo, 100, 100)} alt={item.title} />
        </Link>
      </div>
    </div>),
  },
  // {
  //   name: 'logo',
  //   title: '',
  //   value: ({ item }) => (
  //     <div className="center">
  //       <Link to={ModelService.getUpdateUrl(item.id)}>
  //         <PreviewImage height="35" src={ModelService.getImage(item.logo, 100, 100)} alt={item.title} />
  //       </Link>
  //     </div>
  //   ),
  //   filter: false,
  //   sort: false,
  // },
  {
    name: 'status',
    title: t('Status'),
    value: ({ item: { status } }) => (
      <Badge color={ModelService.getColorByStatus(status)}>
        {ModelService.getStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  {
    name: 'parent_id',
    title: t('Main company'),
    value: ({ item }) => item.parent ? ( <Link to={CompanyService.getUpdateUrl(item.parent_id)}>{item.parent.title} ({item.parent.id})</Link>) : (<span/>),
  },
  {
    name: 'companyType',
    title: t('Type'),
    value: ({ item: { parent_id } }) => parent_id ? (<span>child</span>) : (<span>main</span>),
    filter: gc.selectFilter([
      {value: '', label: "all"},
      {value: 'main', label: "main"},
      {value: 'child', label: "child"},
    ]),
  },
  {
    name: 'is_whitelabel',
    title: t('Is whitelabel'),
    value: ({ item: { is_whitelabel } }) => (
      <Badge color={ModelService.getColorByStatus(is_whitelabel)}>
        {ModelService.getStatusTitle(is_whitelabel, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  {
    name: 'can_change_animation_structure',
    title: t('Edit anim'),
    value: ({ item: { can_change_animation_structure } }) => (
      <Badge color={ModelService.getColorByStatus(can_change_animation_structure)}>
        {ModelService.getStatusTitle(can_change_animation_structure, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  {
    name: 'payment_status',
    title: t('Payment status'),
    value: ({ item: { payment_status: status } }) => (
      <Badge color={ModelService.getColorByPaymentStatus(status)}>
        {ModelService.getPaymentStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getPaymentStatusOptions(t)),
  },
  {
    name: 'payment_type',
    title: t('Payment type'),
    value: ({ item: { payment_type: status } }) => (
      <Badge color={ModelService.getColorByPaymentType(status)}>
        {ModelService.getPaymentTypesTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getPaymentTypesOptions(t)),
  },
  {
    name: 'last_activity_at',
    title: t('Metrics'),
    value: getMetrics,
    filter: false,
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
    service: ModelService,
  }),
);

export default hoistStatics(enhance)(Items);



// WEBPACK FOOTER //
// ./src/views/companies/index.js